module.exports = __webpack_public_path__ + "linkedin.png?257e06f750e29768a33754f961003ade";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/linkedin.png
// module id = 517
// module chunks = 2